import React from "react";

import Form from "react-bootstrap/Form";
import { Col } from "react-bootstrap";
import { EnrollmentSteps, fromOperatorDefault, Validators, formDataDefault, ID_TYPES, ID_TYPES_OPTIONS, STATE_OPTIONS, DateFormat, ExpirationDateFormat} from "Utils/Constants";
import { Regexes } from "Utils/Regexes";
import "react-datepicker/dist/react-datepicker.css";

import TextField from "Components/Fields/TextField";
import SelectField from "Components/Fields/SelectField";
import MaskedField from "Components/Fields/MaskedField";

const IdentificationFields = ({
  formData = formDataDefault,
  fromOperator = fromOperatorDefault,
  onFieldChange = (fieldName, fieldValue, isValid) => { console.warn("onFieldChange not set.") },
  disabled = false
}) => {

  const isDLorST = (idType) => idType === ID_TYPES.DRIVERS_LICENSE || idType === ID_TYPES.STATE_ID;
  const showState = isDLorST(formData.idType);

  /** Reset ID state field if ID type no longer requires state */
  const onIdTypeChange = (fieldName, fieldValue, isValid) => {
    if (!isDLorST(fieldValue))
    {
      onFieldChange('idState', formDataDefault.idState, true);
    }
    onFieldChange(fieldName, fieldValue, isValid);
  };

  return (
    <>
    <Form.Row>
      {fromOperator.id?.includes(EnrollmentSteps.ID.SSN) &&
        <Col xs={12} md={{span:6, offset:3}}>
          <MaskedField
            fieldName="ssn"
            label="SSN#"
            mask="999-99-9999"
            maxLength={11}
            required={true}
            autoComplete="off"
            validators={[Validators.SSN]}
            onValueChanged={onFieldChange}
            disabled={disabled} />
        </Col>
      }
    </Form.Row>
    </>
  );
}
export default IdentificationFields;
